import { styled } from "@mui/material/styles";

export const BackGround = styled("div")(({ theme }) => ({
  background: `linear-gradient(to bottom, ${theme.palette.secondary.main} 61.5%, transparent 100%)`,
  maxHeight: "718px",
  height: "100%",
  width: "100%",
  position: "absolute",
  zIndex: 0,
}));
